// views/user/StreetLight/Store/streetReducer.js
import { combineReducers } from "redux";
import streetLight from "./streetLight";
import streetLightReport from "./streetLightReport";

// Combine street-related reducers
const streetReducer = combineReducers({
  streetLight,
  streetLightReport,
});

export default streetReducer;
